import React from 'react';

interface ProfileLoadErrorProps {
    message: string;
    onSignOut?: () => void | Promise<void>;
}

/**
 * Shown when users/{uid} snapshot FAILED (e.g. permission denied), as opposed to
 * the document simply not existing. Callers must not treat a failed read as an
 * absent profile and walk the user into onboarding.
 */
export const ProfileLoadError: React.FC<ProfileLoadErrorProps> = ({
    message,
    onSignOut,
}) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-bg-primary text-text-primary px-6">
            <div className="max-w-md space-y-4">
                <h2 className="text-2xl font-bold">We couldn't load your account</h2>
                <p className="text-text-secondary text-sm">
                    Your sign-in worked, but we could not read your profile. This is a
                    configuration problem on our side, not something you did. Please contact
                    support rather than retrying.
                </p>
                <p className="text-text-muted text-xs font-mono break-words">{message}</p>
                {onSignOut && (
                    <button
                        type="button"
                        onClick={() => {
                            void onSignOut();
                        }}
                        className="text-accent-electric hover:underline text-sm"
                    >
                        Return to Login
                    </button>
                )}
            </div>
        </div>
    );
};
